import { useState } from "react";

import {
    Typography,
    Stack,
  } from "@mui/material";

import css from '../../../../../styles/backOffice/desktop/main.module.css'
import DeleteTenant from "./features/deleteTenant";
import DisableTenant from "./features/disableTenant";

const FeatureBanner = () =>{
    const [error, setError] = useState('');
    
    return(
        <div className={css.container}>
            <Stack direction="row">
                <DeleteTenant setError={setError} />
                <DisableTenant setError={setError} />
            </Stack>
            <Typography >
                {error}
            </Typography>
        </div>
    
    );

};

export default FeatureBanner;